import { Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy, OnDestroy, Output, EventEmitter } from '@angular/core';
import { RoutePlannerService } from 'src/app/modules/route-planner/services/route-planner/route-planner.service';
import { RoutePlannerDataModel, AALocationModel } from '../../models/route-model';
import { RoutePlannerInputService } from '../../services/route-planner-input/route-planner-input.service';
import { EventsService } from 'src/app/core/services/events.service';
import { MapContextMenuEvents, AAGoogleMapEvents, RouteValidationMessage, AARouteEvents } from 'src/app/core/events/events';
import { LocationManagerService } from '../../services/location-manager/location-manager.service';
import { Enums } from '../../enums/route.enum';
import { AppError } from 'src/app/core/models/constants';
import { RoutePlannerViaService } from '../../services/route-via/route-via.service';

@Component({
    selector: 'aa-route-input',
    templateUrl: './route-input.component.html',
    styleUrls: ['./route-input.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class RouteInputComponent implements OnInit, OnDestroy {

  @Output() showRouteEvent: EventEmitter<any> = new EventEmitter();

  constructor(
    private routePlannerService: RoutePlannerService,
    private eventServices: EventsService,
    private cdr: ChangeDetectorRef,
    private routePlannerViaService: RoutePlannerViaService,
    public locationManager: LocationManagerService,
    private routeInputService: RoutePlannerInputService,
  ) { }

  public routeDataModel: RoutePlannerDataModel;
  public fromLocationModel: AALocationModel;
  public toLocationModel: AALocationModel;

  ngOnInit() {
    this.routeDataModel = this.routePlannerService.routeDataModel;
    this.fromLocationModel = this.routeDataModel.FromLocation;
    this.toLocationModel = this.routeDataModel.ToLocation;

    this.eventServices.on(AAGoogleMapEvents.INVALID_ROUTE, this.invalidRoute);
    this.eventServices.on(MapContextMenuEvents.UPDATE_TO_LOCATION, this.updateLocation);
  }

  ngOnDestroy() {
    this.eventServices.remove(MapContextMenuEvents.UPDATE_TO_LOCATION, this.updateLocation);
    this.eventServices.remove(AAGoogleMapEvents.INVALID_ROUTE, this.invalidRoute);
  }


  private updateLocation = (data: { locationModel: AALocationModel, index: number }) => {
    const locationModel = data.locationModel;
    if (locationModel.RouteType === Enums.RouteType.FromDestination
      || locationModel.RouteType === Enums.RouteType.ToDestination) {
      this.locationManager.setLocationModel(locationModel);
    }

    this.routeInputService.onContextMenuRouteLocation();
    this.cdr.detectChanges();
  }

  private invalidRoute = (model: any) => {
    if (model && model.error) {
      this.locationManager.generalErrorMessage = model.errorMsg;
    } else {
      this.locationManager.generalErrorMessage = '';
    }
    this.cdr.detectChanges();
  }

  public reverseRoute() {
    this.routeInputService.reverseRoute();
    this.fromLocationModel = this.routeDataModel.FromLocation;
    this.toLocationModel = this.routeDataModel.ToLocation;
  }

  clearLocationFromList() {
    this.fromLocationModel.clear();
    if (!this.fromLocationModel.validName()) {
      this.fromLocationModel.clearPredictionList(true, 1);
    }
  }

  clearLocationToList() {
    this.toLocationModel.clear();
    if (!this.toLocationModel.validName()) {
      this.toLocationModel.clearPredictionList(true, 1);
    }
  }

  submitSearch() {
    this.showRouteEvent.emit();
    /*this.locationManager.fromLocation.errorMessage = '';
    this.locationManager.toLocation.errorMessage = '';
    this.eventServices.dispatch(RouteValidationMessage.MAX_VIA_MESSAGE, '');

    if (this.locationManager.fromLocation.Name === '' || this.locationManager.toLocation.Name === '') {
      this.eventServices.dispatch(RouteValidationMessage.FROM_TO_MESSAGE, AppError.ROUTE_LOCATION_MISSING);
      this.eventServices.dispatch(RouteValidationMessage.VIA_MESSAGE, AppError.ROUTE_LOCATION_MISSING);
      return;
    }

    if (this.locationManager.validateFromToLocation() && this.routePlannerViaService.validateViaRoute()) {
      this.routePlannerService.updateGoogleMap();
    } else {
      this.eventServices.dispatch(RouteValidationMessage.FROM_TO_MESSAGE, AppError.ROUTE_LOCATION_NOT_FOUND);
      this.eventServices.dispatch(RouteValidationMessage.VIA_MESSAGE, AppError.ROUTE_LOCATION_NOT_FOUND);
    }*/
  }

  reset(): void {
    this.locationManager.generalErrorMessage = '';
    this.apply();
  }

  apply() {
    setTimeout(() => {
      this.cdr.detectChanges();
    }, 100);
  }
}
